// =====================================================================
//  input-mask.js — Inputmask integration for numeric inputs.
// =====================================================================
import Inputmask from "inputmask";

// Money: thousands grouping, no decimals.
Inputmask({
  alias: 'numeric',
  groupSeparator: ',',
  autoGroup: true,
  digits: 0,
  allowMinus: false,
  unmaskAsNumber: true,
  removeMaskOnSubmit: true,
  rightAlign: false,
}).mask(document.querySelectorAll('.input-number'));

// types. Examples: "5" -> "0.05", "285" -> "2.85", "2222" -> "22.22".
Inputmask({
  alias: 'numeric',
  groupSeparator: '',
  autoGroup: false,
  radixPoint: '.',
  digits: 2,
  digitsOptional: false,
  integerDigits: 2,
  numericInput: true,
  allowMinus: false,
  unmaskAsNumber: true,
  removeMaskOnSubmit: true,
  rightAlign: false,
}).mask(document.querySelectorAll('.input-number-decimals'));

// Plain integer: max 3 digits, no grouping, no decimals.
Inputmask({
  alias: 'numeric',
  groupSeparator: '',
  autoGroup: false,
  digits: 0,
  integerDigits: 3,
  allowMinus: false,
  unmaskAsNumber: true,
  removeMaskOnSubmit: true,
  rightAlign: false,
}).mask(document.querySelectorAll('.input-number-int'));
